import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import GoogleMapReact from "google-map-react";
import MapStyles from "./MapStyles";
import ChargingStationsMapMarker from "../ChargingStationsMapMarker/ChargingStationsMapMarker";

const INITIAL_ZOOM = 4;
const K_HOVER_DISTANCE = 30;
const API_KEY =
  process.env.REACT_APP_ENVIRONMENT === "production"
    ? process.env.REACT_APP_PRODUCTION_GOOGLE_MAP_API_KEY
    : process.env.REACT_APP_STAGING_GOOGLE_MAP_API_KEY;

const DEFAULT_CENTER = {
  lat: 37.54085,
  lng: -77.43930,
};

const BaseGoogleMapReact = ({
  center,
  children,
  onHoverOnStation,
  onHoverOffStation,
  onClickMarker,
  chargingStations,
  selectedStation,
  onGoogleApiLoaded,
  ...rest
}) => {
  const [map, setMap] = useState(null);

  useEffect(() => {
    if (
      map &&
      center &&
      Number.isFinite(center.lat) &&
      Number.isFinite(center.lng)
    ) {
      map.panTo(center);
    }
  }, [map, center]);

  const handleGoogleApiLoaded = ({ map: m, maps }) => {
    setMap(m);
    if (onGoogleApiLoaded) onGoogleApiLoaded({ map: m, maps });
  };

  const hoverProps = {
    ...(onHoverOnStation && {
      onChildMouseEnter: (key, childProps) => {
        onHoverOnStation(childProps.station.id);
      },
    }),
    ...(onHoverOffStation && {
      onChildMouseLeave: onHoverOffStation,
    }),
  };


  return (
    <GoogleMapReact
      bootstrapURLKeys={{
        key: API_KEY,
        libraries: "places",
      }}
      center={center}
      defaultCenter={DEFAULT_CENTER}
      defaultZoom={INITIAL_ZOOM}
      hoverDistance={K_HOVER_DISTANCE}
      options={{ styles: MapStyles }}
      yesIWantToUseGoogleMapApiInternals
      onGoogleApiLoaded={handleGoogleApiLoaded}
      {...hoverProps}
      {...rest}
    >
      {(chargingStations || []).map((station, i) => (
        <ChargingStationsMapMarker
          key={station.id}
          station={station}
          selectedStation={selectedStation}
          lat={station.latitude}
          lng={station.longitude}
          onClick={onClickMarker}
        />
      ))}
      {children}
    </GoogleMapReact>
  );
};

BaseGoogleMapReact.propTypes = {
  center: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number,
  }),
  children: PropTypes.node,
  onClickMarker: PropTypes.func,
  onHoverOnStation: PropTypes.func,
  onHoverOffStation: PropTypes.func,
  chargingStations: PropTypes.array,
  selectedStation: PropTypes.object,
};

BaseGoogleMapReact.defaultProps = {
  chargingStations: [],
  center: DEFAULT_CENTER,
  onClickMarker: () => {},
  showStationsByPowerLevel: true,
  customizeMarkOnHover: () => {},
};

export default BaseGoogleMapReact;
